function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.364 10.636a1.5 1.5 0 010 2.121L19.121 17l4.243 4.243a1.5 1.5 0 01-2.121 2.121L17 19.121l-4.243 4.243a1.5 1.5 0 01-2.121-2.121L14.879 17l-4.243-4.243a1.5 1.5 0 012.121-2.121L17 14.879l4.243-4.243a1.5 1.5 0 012.121 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgBig = function SvgBig(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 34,
      height: 34
    }, props), _ref)
  );
};

export default SvgBig;